const isObject = (obj) => typeof obj === "object" && !Array.isArray(obj) && obj !== null;
export {
  isObject
};
//# sourceMappingURL=is-object.js.map
